export default __webpack_public_path__ + "static/sweepstakes-prize-03-705e894cb01801f0407c7a1b7f0c7d51.jpg";